import { ReactNode } from "react";

import { StoreProvider } from "@/app/providers/StoreProvider";
import { ThemeProvider } from "@/app/providers/ThemeProvider";
import AlertContext from "@/shared/lib/contexts/alertContext";
import ReadersContext from "@/shared/lib/contexts/readersContext";
import TagsContext from "@/shared/lib/contexts/tagsContext";
import AttachContext from "@/shared/lib/contexts/attachFileContext";
import { AlertProvider } from "@/shared/lib/components/Alert";
import { ContextMenuProvider } from "@/shared/lib/components/ContextMenu";

export const withProviders = (component: () => ReactNode) => () => (
  <StoreProvider>
    <AlertProvider>
      <ContextMenuProvider>
        <AlertContext>
          <ReadersContext>
            <TagsContext>
              <AttachContext>
                <ThemeProvider>{component()}</ThemeProvider>
              </AttachContext>
            </TagsContext>
          </ReadersContext>
        </AlertContext>
      </ContextMenuProvider>
    </AlertProvider>
  </StoreProvider>
);
